:root {
  // Default skeleton theme - can be overridden
  --skeleton-bg: var(--background-action-neutral);
  --skeleton-wave: rgba(255, 255, 255, 0.6);
  --skeleton-pulse-from: 1;
  --skeleton-pulse-to: 0.5;
  --skeleton-duration: 1.5s;
}

.SDSSkeleton {
  background-color: var(--skeleton-bg);
  position: relative;
  overflow: hidden;
  display: inline-block;

  // GPU acceleration for smooth animations
  will-change: opacity, transform;
  transform: translateZ(0);

  // Wave animation (default)
  &--animation-wave::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--skeleton-wave), transparent);
    animation: skeleton-wave var(--skeleton-duration) ease-in-out infinite;
  }

  // Pulse animation (alternative)
  &--animation-pulse {
    animation: skeleton-pulse var(--skeleton-duration) ease-in-out infinite;
  }

  // No animation (for reduced motion or explicit disable)
  &--animation-none {
    // Static appearance only
  }

  // Reduced motion specific styling
  &--reduced-motion {
    // Ensure no animations for accessibility
    animation: none !important;

    &::after {
      animation: none !important;
    }
  }

  // Border radius variants
  &--radius-none {
    border-radius: 0;
  }

  &--radius-small {
    border-radius: var(--border-radius-card-small, 4px);
  }

  &--radius-medium {
    border-radius: var(--border-radius-card-medium, 8px);
  }

  &--radius-large {
    border-radius: var(--border-radius-card-large, 12px);
  }

  &--radius-full {
    border-radius: 9999px;
  }
}

// Animation keyframes
@keyframes skeleton-wave {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes skeleton-pulse {
  0%,
  100% {
    opacity: var(--skeleton-pulse-from);
  }
  50% {
    opacity: var(--skeleton-pulse-to);
  }
}

// Respect motion preferences globally
@media (prefers-reduced-motion: reduce) {
  .SDSSkeleton {
    animation: none !important;

    &::after {
      animation: none !important;
    }
  }
}

// Screen reader only class
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
